
import packageData from '../package.json'

var appsettings = {
    systemTitle: "Veranda2",
    appTitle: "Veranda3-Frontend",
    version: packageData.version,
    logo: '/assets/circle_logo_blue_web.svg',
    production: true,
    watermark: 'url("/backend/tailbone/img/testing.png")',
};

export default appsettings;
